// Custom Document API helpers — wraps /api/custom/<slug>{,/docx,/pdf} and
// /api/export-templates.

export interface ExportTemplate {
  id: string;
  label: string;
}

export async function fetchExportTemplates(): Promise<ExportTemplate[]> {
  const r = await fetch("/api/export-templates", { credentials: "include" }).catch(() => null);
  if (!r || !r.ok) return [{ id: "plain", label: "Standard (ohne Vorlage)" }];
  const data = (await r.json()) as ExportTemplate[];
  return Array.isArray(data) && data.length > 0
    ? data
    : [{ id: "plain", label: "Standard (ohne Vorlage)" }];
}

export async function saveCustomDoc(slug: string, content: string): Promise<void> {
  const r = await fetch("/api/custom/" + encodeURIComponent(slug), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content }),
    credentials: "include",
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({ error: r.statusText }));
    throw new Error(err.error || r.statusText || "Speichern fehlgeschlagen");
  }
}

export async function fetchCustomDoc(slug: string): Promise<string | null> {
  const r = await fetch("/api/custom/" + encodeURIComponent(slug), {
    credentials: "include",
  }).catch(() => null);
  if (!r || !r.ok) return null;
  const data = (await r.json()) as { content?: string };
  return data.content ?? "";
}

export async function downloadCustomFile(
  slug: string,
  endpoint: "docx" | "pdf",
  template: string,
): Promise<{ ok: boolean; error?: string }> {
  const r = await fetch(
    `/api/custom/${encodeURIComponent(slug)}/${endpoint}?template=${encodeURIComponent(template)}`,
    { credentials: "include" },
  ).catch(() => null);
  if (!r) return { ok: false, error: "Netzwerkfehler" };
  if (!r.ok) {
    const err = await r.json().catch(() => ({ error: r.statusText }));
    return { ok: false, error: err.error ?? r.statusText };
  }
  const blob = await r.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `custom_doc_${slug}.${endpoint}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return { ok: true };
}
